import { Button, Divider } from '@mui/material';
import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import { ActionButtonsForContent } from 'primary/MessageList/contents/ActionButtonsForContent';
import {
  getNavigationLinkFromRessourceKey,
  parseRessourceFromNotificaton,
} from 'primary/MessageList/NotificationListItem';
import React from 'react';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import { useNavigate } from 'react-router-dom';

import { NotificationResourceTypeEnum } from '../../../domain/notification/NotificationResourceTypeEnum';
import { UnpyNotification } from '../../../domain/notification/UnpyNotification';
import { IRelationRepository } from '../../../domain/relation/relation.repository';
import { RelationStatusEnum } from '../../../domain/relation/RelationStatusEnum';
import {
  TranslationOption,
  TranslationType,
} from '../../../domain/translation/Translation.repository';
import { sendEventToastMessage } from '../../Components/Toast/Toast.helper';
import { routesConfig } from '../../Configs/Routes.config';
import { useContextDependency } from '../../hooks/useContextDependency';
import { useRetrieveFromDomain } from '../../hooks/useRetrieveFromDomain';
import { useTranslate } from '../../hooks/useTranslate';

interface NotificationInvitationStructureContentProps {
  notification: UnpyNotification;
  reFetchNotification: () => void;
  isResponse?: boolean;
  closePreview?: () => void;
}

export const getOnClickResponseAddFriend = (
  relationRepository: IRelationRepository,
  relationId: number | string,
  t: (key: TranslationType, option?: TranslationOption) => string,
  response: boolean,
  reFetchMessage: () => void,
  setLoading: (loading: boolean) => void,
) => {
  return () => {
    setLoading(true);
    relationRepository
      .responseInvitation(parseInt(relationId.toString()), response)
      .then(() => {
        reFetchMessage();
        setLoading(false);
        sendEventToastMessage(
          t('notification.content.invitationFriend.response.sended'),
          'success',
        );
      });
  };
};

export const getOnClickSeeProfilFromAddFriend = (
  navigate: NavigateFunction,
  idProfil: number,
  closePreview?: () => void,
) => {
  return () => {
    navigate(routesConfig.userProfil.to(idProfil));
    closePreview?.();
  };
};

export const NotificationInvitationFriendContent = ({
  notification,
  reFetchNotification,
  isResponse,
  closePreview,
}: NotificationInvitationStructureContentProps) => {
  const t = useTranslate();
  const { relationRepository } = useContextDependency();
  const [relation] = useRetrieveFromDomain(
    () =>
      relationRepository.getById(
        parseInt(notification.resources[NotificationResourceTypeEnum.RELATION_ID]),
      ),
    undefined,
    !!notification.resources[NotificationResourceTypeEnum.RELATION_ID],
  );

  const ressourcesParsed = parseRessourceFromNotificaton(notification);

  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();
  if (!relation) return null;
  return (
    <div>
      <div className={'-keyValueContainerNotification'}>
        {ressourcesParsed
          .filter((r) => !r.isLink)
          .map((res) => (
            <KeyValue
              key={res.keyValue}
              accent
              keyValue={t(
                `notificationList.item.ressourceLabelByKey.${
                  res.keyValue as NotificationResourceTypeEnum
                }`,
              )}
              value={res.value}
            />
          ))}
      </div>
      <div className={'-linkContainerNotification'}>
        {ressourcesParsed
          .filter((r) => r.isLink)
          .map((res) => (
            <Button
              key={res.keyValue}
              variant={'outlined'}
              className={'-linkNotification'}
              onClick={() => {
                const link = getNavigationLinkFromRessourceKey(
                  res.keyValue as NotificationResourceTypeEnum,
                  res.value,
                  notification.resources,
                  notification.type,
                );
                navigate(link);
                closePreview?.();
              }}
            >
              {t(
                `notificationList.item.ressourceLabelByKey.${
                  res.keyValue as NotificationResourceTypeEnum
                }`,
              )}
            </Button>
          ))}
      </div>
      <Divider className={'-topMarged'} />
      {relation?.status === RelationStatusEnum.ACCEPTED && (
        <span>
          {t(
            !isResponse
              ? 'notification.content.invitationFriend.alreadyAccepted'
              : 'notification.content.invitationFriend.response.accepted',
          )}
        </span>
      )}
      {!isResponse && relation && relation.status === RelationStatusEnum.PENDING && (
        <ActionButtonsForContent
          loading={loading}
          onClickExitTo={getOnClickSeeProfilFromAddFriend(
            navigate,
            notification.userFrom.idProfil,
          )}
          onClickCancel={getOnClickResponseAddFriend(
            relationRepository,
            notification.resources[NotificationResourceTypeEnum.RELATION_ID],
            t,
            false,
            reFetchNotification,
            setLoading,
          )}
          onClickValid={getOnClickResponseAddFriend(
            relationRepository,
            notification.resources[NotificationResourceTypeEnum.RELATION_ID],
            t,
            true,
            reFetchNotification,
            setLoading,
          )}
        />
      )}
    </div>
  );
};
